import * as moment from '../../../../node_modules/moment/moment.js';
import { AnnexRendererComponent } from './annex-cell-renderer-component';
import { DragGripCellRenderer } from "./drag-grip-cell-renderer.component";
import { AppUtils } from '../../common/utility/appUtil';
import { CustomTextFilterComponent } from './custom-text-filter/custom-text-filter.component';
import { AgeRangeFilterComponent } from './age-range-filter/age-range-filter.component';
import { CustomDateFilterComponent } from './custom-date-filter/custom-date-filter.component';

export class MailBoxGridColdefs {

  getMailboxColDefs() {
    const width = screen.width * window.devicePixelRatio;
    const columnWidths = this.setColumnWidths(screen.width);
    let objAppUtils = new AppUtils();
    return [
      {
        headerName: '',
        field: 'expander',
        sortable: false,
        suppressMenu: true,
        resizable: false,
        suppressMovable: true,
        hide: false,
        showInSecondary: false,
        suppressSizeToFit: true,
        headerClass: 'no-hover-sort',
        cellRendererSelector: (params) => {

          if (!params.node.group) {
            const convCount = this.getConvCount(params);
            if (convCount <= 1) {
              return {}
            }
            else {
              return { component: 'agGroupCellRenderer' };
            }
          }
          return { };
        },
        headerCheckboxSelection: true,
        suppressColumnVirtualisation: true,
        filter: false,
        width: 50,
        minWidth: 50,
        maxWidth: 50,
        flex:null,
        tooltipValueGetter: (params) => {
          // C153176-4566 | Show Client Category name on hover.
          if (params.node.group) {
            return null;
          } else { // Retrieves the value of the current field
            let category = this.getClientCategory(params);
            return category ? category.categoryName : '';
          }
        },
        cellStyle: (params) => {
          // C153176-4566 | Show Client Category Color Code.
          if (params && params.node && params.node.group) {
            return null;
          } else { // Retrieves the value of the current field
            let category = this.getClientCategory(params);
            if (category) {
              let clntCategoryColorCode = category ? category.colorCode : '';
              return {
                // C153176-4548 | Client category color in inbox behaves abruptly
                borderLeft: '4px solid',
                borderLeftColor: clntCategoryColorCode,
                width: '33px'
              }
            }
            //border which will not visible. To maintain even space for all checkboxes
            else {
              return {
                paddingLeft: '15px',
                width: '35px',
              };
            }
          }

        }
        // DO NOT DELETE will be used when custom category is available
        /*
        cellStyle: function (params) {
          return {
            marginLeft: '5px',
            paddingLeft: '5px',
            paddingRight: '5px',
  //        borderLeftColor: '#f1a840',
   //       borderLeftStyle: 'solid'
          }
        }*/
      },
      {
        headerName: 'From',
        field: 'latestUserName',
        sortingOrder: ["asc", "desc"],
        comparator: (valueA, valueB) => valueA.localeCompare(valueB),
        resizable: true,
        suppressMovable: false,
        hide: false,
        showInSecondary: false,
        suppressColumnVirtualisation: true,
        tooltipField: null,
        suppressSizeToFit: true,
        width: columnWidths.fromWidth,
        minWidth: columnWidths.fromWidthMin,
        maxWidth: columnWidths.fromWidthMax,
        flex: null,
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"],
        filterParams: {},
        cellRenderer: function (params) {
          if (params.node.master) {
            // This means it's a master row, render the icons
            const container = document.createElement("div");
            container.classList.add("buttons");

            const backDiv = document.createElement("div");
            backDiv.classList.add("back");
            backDiv.innerText = params.value;

            const frontDiv = document.createElement("div");
            frontDiv.classList.add("front");

            const gridApi = params.api; // Get the grid API to access selected rows

            const icons = [
              { src: "assets/Inbox/replyStd.svg", hoverSrc: "assets/Inbox/reply-blue.svg", action: "Reply" },
              { src: "assets/Inbox/inboxReplyAll.svg", hoverSrc: "assets/Inbox/reply-all-blue.svg", action: "Reply All" },
              { src: "assets/Inbox/forwardStd.svg", hoverSrc: "assets/Inbox/forward-blue.svg", action: "Forward" },
              { src: "assets/Inbox/resolve-18.svg", hoverSrc: "assets/Inbox/resolve-blue.svg", action: "Resolve" },
              { src: "assets/Inbox/important-18.svg", hoverSrc: "assets/Inbox/important-18.svg", action: "Mark as Important" }
            ];

            icons.forEach(icon => {
              const img = document.createElement("img");
              img.src = icon.src;
              img.alt = icon.action;
              img.style.width = "18px";
              img.style.height = "18px";
              img.style.cursor = "pointer";
              img.title = icon.action;

              img.addEventListener("mouseover", () => img.src = icon.hoverSrc);
              img.addEventListener("mouseout", () => img.src = icon.src);

              img.addEventListener("click", (event) => {
                event.stopPropagation();
                gridApi.deselectAll();
                params.node.setSelected(true);

                if (params.context && params.context.componentParent) {
                  params.context.componentParent.onRowClicked(params);
                }

                setTimeout(() => {
                  if (params.context && params.context.componentParent) {
                    if (icon.action === "Reply") {
                      params.context.componentParent.mailDetailViewComp.onReplyConversation('Reply', params.context.componentParent.mailDetailViewComp.conversationList[0]);
                    }
                    else if (icon.action === "Reply All") {
                      params.context.componentParent.mailDetailViewComp.onReplyConversation('ReplyAll', params.context.componentParent.mailDetailViewComp.conversationList[0]);
                    }
                    else if (icon.action === "Forward") {
                      params.context.componentParent.mailDetailViewComp.onReplyConversation('Forward', params.context.componentParent.mailDetailViewComp.conversationList[0]);
                    }
                    else if (icon.action === "Resolve") {
                      params.context.componentParent.mailDetailViewComp.markResolved();
                    }
                    else if (icon.action === "Mark as Important") {
                      if (params.data.urgentFlag === 'N') {
                        params.data.urgentFlag = 'Y';
                        params.api.refreshCells({ rowNodes: [params.node], force: true });
                      }
                    }
                  }
                }, 200);
              });

              frontDiv.appendChild(img);
            });

            container.appendChild(backDiv);
            container.appendChild(frontDiv);

            return container;
          } else {
            // If it's a detail row, just return the text without the icons
            return params.value;
          }
        }


      },
      {
        "headerName": "Subject",
        "field": "subject",
        suppressMenu: false,
        resizable: true,
        sortingOrder: ["asc", "desc"],
        suppressMovable: false,
        hide: false,
        cellRenderer: "",
        showInSecondary: false,
        suppressColumnVirtualisation: true,
        tooltipField: 'subject',
        suppressSizeToFit: true, /* added in all column due to distored issue C153176-4904 */
        width: columnWidths.subjectWidth,
        minWidth: columnWidths.subjectWidthMin,
        maxWidth: columnWidths.subjectWidthMax,
        flex: null,
        /* width: 137 */
        // fix for C153176-4370 Observation- Limitations with filter not being provided at column level
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"],
        filterParams: {}

      },
      {
        "headerName": "Assigned To",
        "field": "openUsers",
        sortingOrder: ["asc", "desc"],
        comparator: (valueA, valueB) => valueA.localeCompare(valueB),
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        hide: false,
        showInSecondary: false,
        suppressColumnVirtualisation: true,
        tooltipField: 'openUsers',
        suppressSizeToFit: true,    /* added in all column due to distored issue C153176-4904 */
        width: columnWidths.assignedToWidth,
        minWidth: columnWidths.assignedToWidthMin,
        maxWidth: columnWidths.assignedToWidthMax,
        flex: null,
        /* width: 137 */
        // fix for C153176-4370 Observation- Limitations with filter not being provided at column level
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"],
        filterParams: {}
      },
      {
        "headerName": "Assigned From",
        "field": "origUserName",
        sortingOrder: ["asc", "desc"],
        comparator: (valueA, valueB) => valueA.localeCompare(valueB),

        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        hide: false,
        cellRenderer: "",
        showInSecondary: false,
        suppressColumnVirtualisation: true,
        tooltipField: 'origUserName',
        suppressSizeToFit: true, /* added in all column due to distored issue C153176-4904 */
        flex: null,
        minWidth: 100,
        /* width: 137 */
        // fix for C153176-4370 Observation- Limitations with filter not being provided at column level
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"],
        filterParams: {}
      },
      {
        "headerName": "Ownership",
        "field": "hasOwnership",
        sortingOrder: ["asc", "desc"],
        // "width": 100,
        // sortable: true,
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        hide: true,
        cellRenderer: "",
        tooltipField: 'hasOwnership',
        showInSecondary: true,
        suppressSizeToFit: true,
        suppressColumnVirtualisation: true,
        minWidth: 100,
        flex: null,
        // fix for C153176-4370 Observation- Limitations with filter not being provided at column level
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"],
        filterParams: {}
      },
      {
        "headerName": "Request Type",
        "field": "requestTypeStr",
        sortingOrder: ["asc", "desc"],
        hide: true,
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        cellRenderer: "",
        showInSecondary: true,
        suppressSizeToFit: true,
        suppressColumnVirtualisation: true,
        width: 120,
        minWidth: 100,
        flex: null,
        valueGetter: (params) => params?.data?.requestTypeStr ? params.data.requestTypeStr : '',
        // fix for C153176-4370 Observation- Limitations with filter not being provided at column level
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"],
        filterParams: {}
      },
      {
        "headerName": "Processing Region",
        "field": "processingRegion",
        sortingOrder: ["asc", "desc"],
        hide: true,
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        cellRenderer: "",
        suppressColumnVirtualisation: true,
        showInSecondary: true,
        flex: null,
        minWidth: 100,
        suppressSizeToFit: true, /* added in all column due to distored issue C153176-4904 */
        // fix for C153176-4370 Observation- Limitations with filter not being provided at column level
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"],
        filterParams: {}
      },
      {
        "headerName": "Lock",
        "field": "lock",
        hide: true,
        sortingOrder: ["asc", "desc"],
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        cellRenderer: "",
        showInSecondary: true,
        suppressSizeToFit: true,
        suppressColumnVirtualisation: true,
        minWidth: 100,
        flex: null,
        // fix for C153176-4370 Observation- Limitations with filter not being provided at column level
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"],
        filterParams: {}

      },
      {
        "headerName": "Escalation",
        "field": "isEscalated",
        hide: true,
        sortingOrder: ["asc", "desc"],
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        cellRenderer: "",
        showInSecondary: true,
        tooltipField: 'escalationReason',
        suppressSizeToFit: true,
        suppressColumnVirtualisation: true,
        minWidth: 100,
        flex: null,
        // fix for C153176-4370 Observation- Limitations with filter not being provided at column level
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"],
        filterParams: {}

      },
      {
        "headerName": "Id",
        "field": "_id",
        sortingOrder: ["asc", "desc"],
        hide: true,
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        cellRenderer: "",
        showInSecondary: true,
        suppressSizeToFit: true,
        suppressColumnVirtualisation: true,
        width: 100,
        minWidth: 100,
        flex: null,
        // fix for C153176-4370 Observation- Limitations with filter not being provided at column level
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"],
        filterParams: {}

      },
      {
        "headerName": "Last Action",
        "field": "action",
        sortingOrder: ["asc", "desc"],
        hide: true,
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        cellRenderer: "",
        suppressColumnVirtualisation: true,
        showInSecondary: true,
        flex: null,
        minWidth: 100,
        suppressSizeToFit: true /* added in all column due to distored issue C153176-4904 */,
        // fix for C153176-4370 Observation- Limitations with filter not being provided at column level
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"],
        filterParams: {}

      },

      {
        "headerName": "Assigned Group",
        "field": "openGroups",
        sortingOrder: ["asc", "desc"],
        hide: true,
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        cellRenderer: "",
        showInSecondary: true,
        suppressColumnVirtualisation: true,
        tooltipField: 'openGroups',
        suppressSizeToFit: true /* added in all column due to distored issue C153176-4904 */,
        width: columnWidths.assignedGroupWidth,
        minWidth: columnWidths.assignedGroupWidthMin,
        maxWidth: columnWidths.assignedGroupWidthMax,
        // fix for C153176-4370 Observation- Limitations with filter not being provided at column level
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"],
        flex: null,
        filterParams: {}

      },
      {
        "headerName": "Originating Group",
        "field": "origGroupName",
        sortingOrder: ["asc", "desc"],
        hide: true,
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        cellRenderer: "",
        showInSecondary: true,
        suppressColumnVirtualisation: true,
        tooltipField: 'origGroupName',
        minWidth: 100,
        suppressSizeToFit: true /* added in all column due to distored issue C153176-4904 */,
        // fix for C153176-4370 Observation- Limitations with filter not being provided at column level
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"],
        flex: null,
        filterParams: {}

      },
      {
        "headerName": "Created Date",
        "field": "crtDate.$date",
        sortingOrder: ["asc", "desc"],
        hide: true,
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        showInSecondary: true,
        suppressColumnVirtualisation: true,
        flex: null,
        minWidth: 100,
        suppressSizeToFit: true, /* added in all column due to distored issue C153176-4904 */
        cellRenderer: (data) => {
          // console.log(data.value);
          return objAppUtils.convertDate(data.value)
        },
        tooltipValueGetter: (data) => {
          return objAppUtils.convertDate(data.value)
        },
        // fix for C153176-4370 Observation- Limitations with filter not being provided at column level
        // filter: 'agDateColumnFilter',
        // menuTabs: ["filterMenuTab"],
        // filterParams: this.getFilterParamsDate()
        filter: CustomDateFilterComponent,
        menuTabs: ['filterMenuTab'],
        filterParams: {},

      },

      {
        "headerName": "Inquiry Status",
        "field": "status",
        sortingOrder: ["asc", "desc"],
        hide: true,
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        cellRenderer: "",
        suppressColumnVirtualisation: true,
        showInSecondary: true,
        flex: null,
        minWidth: 100,
        suppressSizeToFit: true       /* added in all column due to distored issue C153176-4904 */,
        // fix for C153176-4370 Observation- Limitations with filter not being provided at column level
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"],
        filterParams: {}
      },
      {
        "headerName": "Tag",
        "field": "tag",
        sortingOrder: ["asc", "desc"],
        hide: true,
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        cellRenderer: "",
        suppressColumnVirtualisation: true,
        showInSecondary: true,
        flex: null,
        minWidth: 100,
        suppressSizeToFit: true  /* added in all column due to distored issue C153176-4904 */,
        // fix for C153176-4370 Observation- Limitations with filter not being provided at column level
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"],
        filterParams: {}
      },
      {
        "headerName": "Re-open Age(Days)",
        "field": "reOpenAge",
        sortingOrder: ["asc", "desc"],
        hide: true,
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        cellRenderer: "",
        flex: null,
        minWidth: 100,
        suppressColumnVirtualisation: true,
        showInSecondary: true,
        suppressSizeToFit: true,/* added in all column due to distored issue C153176-4904 */
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"],
        filterParams: {}

      },
      {
        "headerName": "Re-open Date",
        "field": "reOpenDate.$date",
        sortingOrder: ["asc", "desc"],
        hide: true,
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        // cellRenderer: "",
        showInSecondary: true,
        flex: null,
        minWidth: 100,
        suppressSizeToFit: true,  /* added in all column due to distored issue C153176-4904 */
        suppressColumnVirtualisation: true,
        cellRenderer: (data) => {
          return objAppUtils.convertDate(data.value)
        },
        tooltipValueGetter: (data) => {
          return objAppUtils.convertDate(data.value)
        },
        // fix for C153176-4370 Observation- Limitations with filter not being provided at column level
        // filter: 'agDateColumnFilter',
        // menuTabs: ["filterMenuTab"],
        // filterParams: this.getFilterParamsDate()
        filter: CustomDateFilterComponent,
        menuTabs: ['filterMenuTab'],
        filterParams: {},

      },
      {
        "headerName": "Last Action By",
        "field": "lastActionby",
        sortingOrder: ["asc", "desc"],
        hide: true,
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        cellRenderer: "",
        suppressColumnVirtualisation: true,
        flex: null,
        minWidth: 100,
        showInSecondary: true,
        suppressSizeToFit: true  /* added in all column due to distored issue C153176-4904 */,
        // fix for C153176-4370 Observation- Limitations with filter not being provided at column level
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"],
        filterParams: {}

      },
      {
        "headerName": "Last Action Time",
        "field": "lastActionTime.$date",
        sortingOrder: ["asc", "desc"],
        hide: true,
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        suppressColumnVirtualisation: true,
        flex: null,
        minWidth: 100,
        suppressSizeToFit: true,  /* added in all column due to distored issue C153176-4904 */
        //cellRenderer: "",
        showInSecondary: true,
        cellRenderer: (data) => {
          return objAppUtils.convertDate(data.value)
        },
        tooltipValueGetter: (data) => {
          return objAppUtils.convertDate(data.value)
        },
        // fix for C153176-4370 Observation- Limitations with filter not being provided at column level
        // filter: 'agDateColumnFilter',
        // menuTabs: ["filterMenuTab"],
        // filterParams: this.getFilterParamsDate()
        filter: CustomDateFilterComponent,
        menuTabs: ['filterMenuTab'],
        filterParams: {},
      },
      {
        "headerName": "Resolver",
        "field": "resolver",
        sortingOrder: ["asc", "desc"],
        hide: true,
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        cellRenderer: "",
        suppressColumnVirtualisation: true,
        showInSecondary: true,
        flex: null,
        minWidth: 100,
        suppressSizeToFit: true  /* added in all column due to distored issue C153176-4904 */,
        // fix for C153176-4370 Observation- Limitations with filter not being provided at column level
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"],
        filterParams: {}

      },
      {
        "headerName": "Resolve Time",
        "field": "resolveTime.$date",
        sortingOrder: ["asc", "desc"],
        hide: true,
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        showInSecondary: true,
        flex: null,
        minWidth: 100,
        suppressColumnVirtualisation: true,
        suppressSizeToFit: true,  /* added in all column due to distored issue C153176-4904 */
        cellRenderer: (data) => {
          //C153176-5065 | Resolve time should be shown correctly
          return objAppUtils.convertDate(data.value);
        },
        tooltipValueGetter: (data) => {
          return objAppUtils.convertDate(data.value);
        },
        // fix for C153176-4370 Observation- Limitations with filter not being provided at column level
        // filter: 'agDateColumnFilter',
        // menuTabs: ["filterMenuTab"],
        // filterParams: this.getFilterParamsDate()
        filter: CustomDateFilterComponent,
        menuTabs: ['filterMenuTab'],
        filterParams: {},
      },
      {
        "headerName": "Sending Entity",
        "field": "clientName",
        sortingOrder: ["asc", "desc"],
        hide: true,
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        cellRenderer: "",
        suppressColumnVirtualisation: true,
        showInSecondary: true,
        flex: null,
        minWidth: 100,
        suppressSizeToFit: true  /* added in all column due to distored issue C153176-4904 */,
        // fix for C153176-4370 Observation- Limitations with filter not being provided at column level
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"],
        filterParams: {}

      },
      {
        "headerName": "Ext Client ID",
        "field": "gpNum",
        sortingOrder: ["asc", "desc"],
        hide: true,
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        cellRenderer: "",
        showInSecondary: true,
        suppressColumnVirtualisation: true,
        tooltipField: 'gpNum',
        flex: null,
        minWidth: 100,
        suppressSizeToFit: true   /* added in all column due to distored issue C153176-4904 */,
        // fix for C153176-4370 Observation- Limitations with filter not being provided at column level
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"],
        filterParams: {}

      },
      {
        "headerName": "Ext Client Name",
        "field": "gpName",
        sortingOrder: ["asc", "desc"],
        hide: true,
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        cellRenderer: "",
        showInSecondary: true,
        tooltipField: 'gpName',
        flex: null,
        minWidth: 100,
        suppressColumnVirtualisation: true,
        suppressSizeToFit: true   /* added in all column due to distored issue C153176-4904 */,
        // fix for C153176-4370 Observation- Limitations with filter not being provided at column level
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"],
        filterParams: {}

      },
      {
        "headerName": "Root Cause",
        "field": "rootCause",
        sortingOrder: ["asc", "desc"],
        hide: true,
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        cellRenderer: "",
        suppressColumnVirtualisation: true,
        showInSecondary: true,
        flex: null,
        minWidth: 100,
        suppressSizeToFit: true /* added in all column due to distored issue C153176-4904 */,
        // fix for C153176-4370 Observation- Limitations with filter not being provided at column level
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"],
        filterParams: {}

      },
      {
        "headerName": "Response Time ",
        "field": "responseTimeQMA",
        sortingOrder: ["asc", "desc"],
        hide: true,
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        cellRenderer: "",
        suppressColumnVirtualisation: true,
        showInSecondary: true,
        flex: null,
        minWidth: 100,
        suppressSizeToFit: true /* added in all column due to distored issue C153176-4904 */,
        // fix for C153176-4370 Observation- Limitations with filter not being provided at column level
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"],
        filterParams: {},
        valueGetter: (params) => {
          const row = params.data;
          if (!row) {
            return undefined;
          }
          return this.formatDuration(Number(row.responseTimeQMA));
        },
        comparator: this.durationComparator
      },
      {
        "headerName": "Query Count",
        "field": "queryCount",
        sortingOrder: ["asc", "desc"],
        hide: true,
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        cellRenderer: "",
        suppressColumnVirtualisation: true,
        flex: null,
        minWidth: 100,
        showInSecondary: true,
        suppressSizeToFit: true /* added in all column due to distored issue C153176-4904 */,
        // fix for C153176-4370 Observation- Limitations with filter not being provided at column level
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"],
        filterParams: {}

      },
      {
        "headerName": "Avg. Response Time",
        "field": "avgResponseTimeQMA",
        sortingOrder: ["asc", "desc"],
        hide: true,
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        cellRenderer: "",
        suppressColumnVirtualisation: true,
        showInSecondary: true,
        flex: null,
        minWidth: 100,
        suppressSizeToFit: true  /* added in all column due to distored issue C153176-4904 */,
        // fix for C153176-4370 Observation- Limitations with filter not being provided at column level
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"],
        filterParams: {},

        valueGetter: (params) => {
          const avgrow = params.data;
          if (!avgrow) {
            return undefined;
          }
          
          const responseTime = Number(avgrow.responseTimeQMA);
          const replyCount = Number(avgrow.replyCountQMA);

          if (
            !Number.isFinite(responseTime) || responseTime <= 0 ||
            !Number.isFinite(replyCount) || replyCount <= 0
          ) {
            avgrow.avgResponseTimeQMA = undefined;
            return undefined;
          }

          const avg = Math.round(responseTime / replyCount);
          avgrow.avgResponseTimeQMA = avg;
          return this.formatDuration(avg);
        },
        comparator: this.durationComparator

      },
      {
        "headerName": "Inquiry Source",
        "field": "inquirySource",
        sortingOrder: ["asc", "desc"],
        hide: true,
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        cellRenderer: "",
        suppressColumnVirtualisation: true,
        flex: null,
        minWidth: 100,
        showInSecondary: true,
        suppressSizeToFit: true  /* added in all column due to distored issue C153176-4904 */,
        // fix for C153176-4370 Observation- Limitations with filter not being provided at column level
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"],
        filterParams: {}

      },
      {
        "headerName": "Inquiry Sub-status",
        "field": "inquirySubStatus",
        sortingOrder: ["asc", "desc"],
        hide: false,
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        cellRenderer: "",
        suppressColumnVirtualisation: true,
        flex: null,
        minWidth: 100,
        showInSecondary: false,
        suppressSizeToFit: true  /* added in all column due to distored issue C153176-4904 */,
        // fix for C153176-4370 Observation- Limitations with filter not being provided at column level
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"],
        filterParams: {}

      },
      {
        "headerName": "Exception Id",
        "field": "exceptionId",
        sortingOrder: ["asc", "desc"],
        hide: true,
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        suppressColumnVirtualisation: true,
        cellRenderer: "",
        showInSecondary: true,
        flex: null,
        minWidth: 100,
        suppressSizeToFit: true    /* added in all column due to distored issue C153176-4904 */,
        // fix for C153176-4370 Observation- Limitations with filter not being provided at column level
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"],
        filterParams: {}

      },
      {
        "headerName": "Client Chase Count",
        "field": "clientChaseCounter",
        sortingOrder: ["asc", "desc"],
        hide: true,
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        suppressColumnVirtualisation: true,
        cellRenderer: "",
        showInSecondary: true,
        flex: null,
        minWidth: 100,
        suppressSizeToFit: true   /* added in all column due to distored issue C153176-4904 */,
        // fix for C153176-4370 Observation- Limitations with filter not being provided at column level
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"],
        filterParams: {}

      },
      {
        "headerName": "Originator Type",
        "field": "origType",
        sortingOrder: ["asc", "desc"],
        hide: true,
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        suppressColumnVirtualisation: true,
        cellRenderer: "",
        flex: null,
        minWidth: 100,
        showInSecondary: true,
        suppressSizeToFit: true  /* added in all column due to distored issue C153176-4904 */,
        // fix for C153176-4370 Observation- Limitations with filter not being provided at column level
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"],
        filterParams: {}

      },
      {
        "headerName": "Originator Email",
        "field": "origEmail",
        sortingOrder: ["asc", "desc"],
        hide: true,
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        cellRenderer: "",
        suppressColumnVirtualisation: true,
        showInSecondary: true,
        tooltipField: 'origEmail',
        flex: null,
        minWidth: 100,
        suppressSizeToFit: true        /* added in all column due to distored issue C153176-4904 */,
        // fix for C153176-4370 Observation- Limitations with filter not being provided at column level
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"],
        filterParams: {}

      },
      {
        "headerName": "Workflow Status",
        "field": "workflowStatus",
        sortingOrder: ["asc", "desc"],
        hide: true,
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        cellRenderer: "",
        showInSecondary: true,
        suppressColumnVirtualisation: true,
        tooltipField: 'workflowStatus',
        flex: null,
        minWidth: 100,
        suppressSizeToFit: true     /* added in all column due to distored issue C153176-4904 */,
        // fix for C153176-4370 Observation- Limitations with filter not being provided at column level
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"],
        filterParams: {}

      },
      {
        "headerName": "Re-age Date",
        "field": "reAgeDate.$date",
        hide: true,
        sortingOrder: ["asc", "desc"],
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        //cellRenderer: "",
        showInSecondary: true,
        suppressColumnVirtualisation: true,
        suppressSizeToFit: true,
        flex: null,
        minWidth: 100,
        cellRenderer: (data) => {
          return objAppUtils.convertDate(data.value)
        },
        tooltipValueGetter: (data) => {
          return objAppUtils.convertDate(data.value)
        },
        // fix for C153176-4370 Observation- Limitations with filter not being provided at column level
        // filter: 'agDateColumnFilter',
        // menuTabs: ["filterMenuTab"],
        // filterParams: this.getFilterParamsDate()
        filter: CustomDateFilterComponent,
        menuTabs: ['filterMenuTab'],
        filterParams: {},

      },
      {
        "headerName": "Escalation Reason",
        "field": "escalationReason",
        sortingOrder: ["asc", "desc"],
        hide: true,
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        cellRenderer: "",
        suppressColumnVirtualisation: true,
        showInSecondary: true,
        flex: null,
        minWidth: 100,
        tooltipField: "escalationReason",
        suppressSizeToFit: true    /* added in all column due to distored issue C153176-4904 */,
        // fix for C153176-4370 Observation- Limitations with filter not being provided at column level
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"],
        filterParams: {}

      },
      {
        "headerName": "Age(hrs)",
        "field": "ageInHrs",
        sortingOrder: ["asc", "desc"],
        hide: true,
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        cellRenderer: "",
        flex: null,
        minWidth: 100,
        showInSecondary: true,
        suppressColumnVirtualisation: true,
        // filter: "agNumberColumnFilter",
        // fix for C153176-4370 Observation- Limitations with filter not being provided at column level
        suppressSizeToFit: true     /* added in all column due to distored issue C153176-4904 */,
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"],
        filterParams: {
          caseSensitive: true,
        }

      },
      {
        "headerName": "Re-open Age(hrs)",
        "field": "reOpenAgeInHrs",
        sortingOrder: ["asc", "desc"],
        hide: true,
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        cellRenderer: "",
        suppressColumnVirtualisation: true,
        showInSecondary: true,
        flex: null,
        minWidth: 100,
        suppressSizeToFit: true  /* added in all column due to distored issue C153176-4904 */,
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"],
        filterParams: {}

      },
      {
        headerName: "Received",
        field: "modDate.$date",
        sortingOrder: ["asc", "desc"],
        hide: false,
        suppressMenu: false,
        resizable: true,
        flex: null,
        suppressMovable: false,
        /*  width: 137, */
        showInSecondary: false,
        suppressSizeToFit: true,  /* added in all column due to distored issue C153176-4904 */
        width: columnWidths.receivedWidth,
        minWidth: columnWidths.receivedWidthMin,
        maxWidth: columnWidths.receivedWidthMax,
        suppressColumnVirtualisation: true,
        // // fix for C153176-4370 Observation- Limitations with filter not being provided at column level
        // filter: 'agDateColumnFilter',
        // menuTabs: ["filterMenuTab"],
        filter: CustomDateFilterComponent,
        menuTabs: ['filterMenuTab'],
        filterParams: {},
        cellRenderer: function (params) {
          if (params.node.group) {
            return null;
          } else { // Retrieves the value of the current field
            return objAppUtils.convertDate(params.getValue())
          }
        },
        tooltipValueGetter: (params) => {
          if (params.node.group) {
            return null;
          } else { // Retrieves the value of the current field
            if (typeof params.data.modDate === 'object') {
              return objAppUtils.convertDate(params.data.modDate.$date)
            } else {
              return params.data.modDate;
            }
          }
        },

      },
      {
        "headerName": "Age", // C153176-5191 AGE(DAYS) -> AGE, AGE(HRS) stays unchanged
        "field": "age",
        sortingOrder: ["asc", "desc"],
        hide: false,
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        showInSecondary: false,
        suppressSizeToFit: true,  /* added in all column due to distored issue C153176-4904 */
        suppressColumnVirtualisation: true,
        width: columnWidths.ageWidth,
        minWidth: columnWidths.ageWidthMin,
        maxWidth: columnWidths.ageWidthMax,
        flex: null,
        // filter: "agNumberColumnFilter",
        // menuTabs: ["filterMenuTab"],
        // filterParams: {
        //   suppressMiniFilter: false, // Shows the search box in the filter popup
        //   cellRenderer: (params: any) => {
        //     return params.value === null ? null : Number(params.value);
        //   },
        //   comparator: (a: number, b: number) => {
        //     if (a == null) return -1;
        //     if (b == null) return 1;
        //     return Number(a) - Number(b);
        //   },
        //   suppressSorting: false, // Allows sorting of filter values
        // },
        filter: AgeRangeFilterComponent,
        menuTabs: ["filterMenuTab"],
        cellRenderer: function (params) {

          if (params.value < 2) {
            return "<div class='qma-inbox-age qma-inbox-age-0-1'> 0-1 days</div>";

          }
          if (params.value > 1 && params.value < 6) {
            return "<div class='qma-inbox-age qma-inbox-age-2-5'> 2-5 days</div>";

          }
          if (params.value > 5 && params.value < 16) {
            return "<div class='qma-inbox-age qma-inbox-age-6-15'> 6-15 days</div>";

          }
          if (params.value >= 16) {
            return "<div class='qma-inbox-age qma-inbox-age-gt-15'> 16+ days</div>";

          }
          return "";
        }

      },
      {
        "headerName": "Read By",
        "field": "readBy",
        sortingOrder: ["asc", "desc"],
        hide: true,
        showInSecondary: true,
        tooltipField: "readBy",
        filter: CustomTextFilterComponent,
        suppressMenu: false,
        resizable: true,
        suppressMovable: false,
        suppressColumnVirtualisation: true,
        cellRenderer: "",
        suppressSizeToFit: true, /* added in all column due to distored issue C153176-4904 */
        menuTabs: ["filterMenuTab"],
        flex: null,
        minWidth: 100,
        filterParams: {},
      },
      {
        "headerName": "Conversation Count",
        "field": "convCount",
        sortingOrder: ["asc", "desc"],
        hide: false,
        showInSecondary: false,
        suppressMenu: false,
        suppressColumnVirtualisation: true,
        // sortable: true,
        resizable: true,
        flex: null,
        minWidth: 100,
        //filter: "agNumberColumnFilter",
        suppressSizeToFit: true,  /* added in all column due to distored issue C153176-4904 */
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"],
        filterParams: {
          caseSensitive: true,
        },
      },
      {
        "headerName": "Client Category",
        "field": "clntCstmCategory",
        sortingOrder: ["asc", "desc"],
        hide: true,
        showInSecondary: false,
        suppressMenu: false,
        suppressColumnVirtualisation: true,
        // sortable: true,
        resizable: true,
        flex: null,
        minWidth: 100,
        suppressSizeToFit: true,  /* added in all column due to distored issue C153176-4904 */
        menuTabs: ["filterMenuTab"],
        filter: CustomTextFilterComponent,
        filterParams: {}
      },
      {
        "headerName": "Annex",
        "field": "followUp",
        suppressMenu: true,
        sortingOrder: ["asc", "desc"],
        // sortable: true,
        resizable: false,
        hide: false,
        suppressMovable: false,
        width: columnWidths.annexWidth,
        minWidth: columnWidths.annexWidthMin,
        maxWidth: columnWidths.annexWidthMax,
        flex: 1,
        showInSecondary: false,
        sortable: false,
        headerClass: 'no-hover-sort',
        suppressSizeToFit: true,   /* added in all column due to distored issue C153176-4904 */
        suppressColumnVirtualisation: true,
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"],
        cellRenderer: AnnexRendererComponent,
        // cellRenderer: function (params) {
        //   if (params.node.group) {
        //     return null;
        //   } else { // Retrieves the value of the current field
        //     let prevtimeTakenAnnex = sessionStorage.getItem("annexTimeTaken");
        //     let t0 = performance.now();
        //     var followupFlag = "";
        //     var autoAssignedFlag = "";
        //     var notesFlag = params.data.notesFlag === "Y" ? "<span class='qma-inbox-notes'><img class='mailbox-notes' src='assets/Inbox/notes_icon_selected_u108.svg' alt='Kiwi standing on oval'></span>" : "<span class='qma-inbox-notes'></span>";
        //     // C153176-5407 Use workflow attachment flag to show attachemtn in grid
        //     var attachFlag = "<span class='qma-inbox-attachement'></span>";
        //     let matchingWf = params.data.workflows.find(wf => wf.assignedGroupName === params.data.openGroups);
        //     if (matchingWf) {
        //       if (matchingWf.attchFlag && matchingWf.attchFlag === "Y") {
        //         attachFlag = "<span class='qma-inbox-attachement'><img class='' src='assets/Inbox/attachments_icon_selected_u107.svg' alt='Kiwi standing on oval'></span>";
        //       }
        //     }
        //     var esclationFlag = params.data.isEscalated === "Y" ?
        //       "<span class='qma-inbox-escalated'><i class='fa fa-exclamation-triangle' style='color:red;' title='" +
        //       params.data.escalationReason + "'></i></span>" : "<span class='qma-inbox-escalated'></span>";
        //     var important = params.data.urgentFlag === "Y" ? "<span class='qma-inbox-urgentFlg'> <i class='fa fa-exclamation' style='color: \#751919;'></i></span>" : "<span class='qma-inbox-urgentFlg'></span>";
        //     if ((params.data.followUp && params.data.followUp === "Y") ||
        //       (params.data.followUp && params.data.followUp.flag && params.data.followUp.flag === "Generic")) {
        //       followupFlag = "<span class='qma-inbox-followup'><img src='assets/Inbox/follow_up_icon_u112.svg' class='qma-grid-followup' alt='Kiwi standing on oval' class='qma-grid-followup'></span>";
        //     } else {
        //       followupFlag = "<span class='qma-inbox-followup'></span>";

        //     }

        //     // var nlp = (params.data.suggestionIndicator === "O" || params.data.suggestionIndicator === "R" || params.data.suggestionIndicator === "B" || params.data.suggestionIndicator === "G") ? "<span class='qma-inbox-nplm'><img src='assets/Inbox/nlp_icon_selected_u104.svg' alt='Kiwi standing on oval'></span>" : "";
        //     /*C153176-4660 Nlp icon some times blank so annex icon distorted*/
        //     let nlp = "<span class='qma-inbox-nplm mailbox-img-nlp'></span>";
        //     if (params.data.suggestionIndicator) {
        //       switch (params.data.suggestionIndicator) {
        //         case "O": {
        //           nlp = "<span class='qma-inbox-nplm'><img src='assets/Inbox/nlp_icon_selected_u104_orange.svg' class='mailbox-img' alt='Kiwi standing on oval'></span>";
        //           break;
        //         }
        //         case "R": {
        //           nlp = "<span class='qma-inbox-nplm'><img src='assets/Inbox/nlp_icon_selected_u104_red.svg' class='mailbox-img' alt='Kiwi standing on oval'></span>";
        //           break;
        //         }
        //         case "B": {
        //           nlp = "<span class='qma-inbox-nplm'><img src='assets/Inbox/nlp_icon_selected_u104.svg' class='mailbox-img' alt='Kiwi standing on oval'></span>";
        //           break;
        //         }
        //         case "G": {
        //           nlp = "<span class='qma-inbox-nplm'><img src='assets/Inbox/nlp_icon_selected_u104_green.svg' class='mailbox-img' alt='Kiwi standing on oval'></span>";
        //           break;
        //         }
        //         default: {
        //           nlp = "<span class='qma-inbox-nplm mailbox-img-nlp'></span>";
        //           break;
        //         }

        //       }
        //     }

        //     if (params.data.autoAssigned && params.data.autoAssigned === "Y") {
        //       autoAssignedFlag = "<span class='qma-inbox-nplm'><img src='assets/Inbox/auto-assign.svg' class='mailbox-img' alt='Kiwi standing on oval'></span>";
        //     } else {
        //       autoAssignedFlag = "<span class='qma-inbox-nplm mailbox-img-nlp'></span>";

        //     }
        //     var t1 = performance.now();
        //     if (prevtimeTakenAnnex) {
        //       const newtimeTaken = JSON.parse(sessionStorage.getItem("annexTimeTaken")) + (t1 - t0);
        //       sessionStorage.setItem("annexTimeTaken", newtimeTaken);
        //     } else {
        //       sessionStorage.setItem("annexTimeTaken", JSON.stringify(t1 - t0));
        //     }
        //     if (params.data.age && params.data.modDate.$date) {

        //       return "<div class='qma-mailbox-annex'>" + "<div class='mailbox-icons-placeholder'>" + important + esclationFlag + nlp + followupFlag + attachFlag + notesFlag + autoAssignedFlag + "</div>" + "</div>";
        //     } else {
        //       return "<div class='qma-mailbox-annex-single-line'>" + important + esclationFlag + nlp + followupFlag + attachFlag + notesFlag + autoAssignedFlag + "</div>";
        //     }

        //   }



        // }

      },
      {
        headerName: 'Category', // category column
        field: 'category',
        sortingOrder: ["asc", "desc"],
        sortable: true,
        resizable: true,
        suppressMovable: false,
        hide: true,
        showInSecondary: false,
        flex: null,
        minWidth: 100,
        suppressColumnVirtualisation: true,
        suppressSizeToFit: true,
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"]
      },
      {
        headerName: 'Attachement',
        field: 'attchFlag',
        sortable: true,
        sortingOrder: ["asc", "desc"],
        resizable: true,
        suppressMovable: false,
        hide: true,
        showInSecondary: false,
        suppressColumnVirtualisation: true,
        suppressSizeToFit: true,
        flex: null,
        minWidth: 100,
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"]
      },
      {
        "headerName": "Time in Queue",
        "field": "timeInQueue",
        hide: true,
        sortingOrder: ["asc", "desc"],
        showInSecondary: false,
        suppressMenu: false,
        suppressColumnVirtualisation: true,
        sortable: true,
        resizable: true,
        suppressSizeToFit: true,  /* added in all column due to distored issue C153176-4904 */
        menuTabs: ["filterMenuTab"],
        flex: null,
        minWidth: 100,
        filter: false, //QMQ-583 remove filer Time In Queue
        filterParams: {},
        // [C170665-1456] Time in Queue sorting issue
        comparator: (valueA, valueB) => {
          const objA = this.createKeyValueObj(valueA);
          const objB = this.createKeyValueObj(valueB);
          let objAMinutes = 0;
          let objBMinutes = 0;
          if (objA['days']) {
            objAMinutes = objA['days'] * 1440;
          }
          if (objA['hours']) {
            objAMinutes = objAMinutes + (objA['hours'] * 60);
          }
          if (objA['mins']) {
            objAMinutes = objAMinutes + (objA['mins']);
          }
          if (objB['days']) {
            objBMinutes = objB['days'] * 1440;
          }
          if (objB['hours']) {
            objBMinutes = objBMinutes + (objB['hours'] * 60);
          }
          if (objB['mins']) {
            objBMinutes = objBMinutes + (objB['mins']);
          }
          return objAMinutes - objBMinutes;
        }
      },
      {
        "headerName": "Reply Count", /* C170665-85 |  Query Count equivalent to CitiReplyCountFromQMA*/
        "field": "citiReplyCountFromQMA",
        hide: true,
        sortingOrder: ["asc", "desc"],
        showInSecondary: false,
        suppressMenu: false,
        suppressColumnVirtualisation: true,
        // sortable: true,
        resizable: true,
        suppressSizeToFit: true,
        menuTabs: ["filterMenuTab"],
        flex: null,
        minWidth: 100,
        filter: CustomTextFilterComponent,
        filterParams: {}
      },
      {
        headerName: 'Recent Note',
        field: 'userNotes',
        sortingOrder: ["asc", "desc"],
        sortable: true,
        resizable: true,
        suppressMovable: false,
        hide: true,
        showInSecondary: false,
        suppressColumnVirtualisation: true,
        suppressSizeToFit: true,
        flex: null,
        minWidth: 100,
        filter: CustomTextFilterComponent,
        menuTabs: ["filterMenuTab"],
        cellRenderer: (params) => { // out of multiple notes show recent one
          let recctNoteContent = '';
          if (params.value && params.value.length > 0) {
            const recentNoteObject = params.value[params.value.length - 1];
            if (recentNoteObject && recentNoteObject.comments) {
              recctNoteContent = recentNoteObject.comments;
            }
          }
          return recctNoteContent;
        }
      }
    ];
  }

  static dateFormats = [
    'DD/MM/YYYY HH:mm:ss',
    'MM/DD/YYYY HH:mm:ss',
    'MM/DD/Y HH:mm:ss',
    'DD/MM/Y HH:mm:ss',
    'MMMM DD YYYY HH:mm:ss',
    'MMMM DD Y HH:mm:ss',
  ];

  static getSearchStateColumnDef() {
    return {
      "headerName": "State",
      "field": "direction",
      hide: false,
      suppressMenu: false,
      resizable: true,
      suppressMovable: false,
      showInSecondary: false,
      suppressSizeToFit: true,  /* added in all column due to distored issue C153176-4904 */
      sortable: true,
      width: 140,
      filter: CustomTextFilterComponent,
      menuTabs: ["filterMenuTab"],
      cellRenderer: function (params) {
        if (params.value) {
          if (params.value === 'IN') {
            return 'Inbox';
          } else if (params.value == 'OUT') {
            return 'Outbox';
          }
        }
        return params.value;
      }
    };

  }

  /**
   * Method to get the client Category with color code and name.
   * @param params
   */
  getClientCategory(params) {
    // C153176-4566 : Show System Defualt or Custom client category. System client category have precedence over custom client.
    // System Client Category
    let clientCategory = null;
    if (params.data.workflows) {
      const clntCtgryWf = params.data.workflows.find(x => x.clientCategory);
      if (clntCtgryWf && clntCtgryWf.clientCategory) {
        clientCategory = clntCtgryWf.clientCategory;
      }
    }


    // Default Client Category
    let customClientCategory = null;
    if (params.data.workflows) {
      const cstmCtgryWf = params.data.workflows.find(x => x.customClientCategory);
      if (cstmCtgryWf && cstmCtgryWf.customClientCategory) {
        customClientCategory = cstmCtgryWf.customClientCategory[0];
      }
    }
    let finalClientCategory = clientCategory ? clientCategory : customClientCategory;
    return finalClientCategory;
  }

  /**
  * Method to get the conversation count.
  * @param params
  */
  getConvCount(params) {
    let converasationCount = 0;
    if (params.data.workflows) {
      const conversation = params.data.workflows.find(x => x.convCount);
      if (conversation && conversation.convCount) {
        converasationCount = conversation.convCount;
      }
    }
    return converasationCount;
  }

  // C153176-5583 Include Null & Not Null into filters from drop down in Grid
  getFilterParams() {
    return {
      filterOptions: [
        'contains', 'notContains', 'equals', 'notEqual', 'startsWith', 'endsWith',
        {
          displayKey: 'blanks',
          displayName: 'Is null',
          test: function (filterValue, cellValue) {
            return cellValue == null || cellValue == "";
          },
          hideFilterInput: true,
        },
        {
          displayKey: 'nonblanks',
          displayName: 'Is not null',
          test: function (filterValue, cellValue) {
            return cellValue != null && cellValue != "";
          },
          hideFilterInput: true,
        }
      ]
    };
  }
  // C153176-5583 Include Null & Not Null into filters from drop down in Grid
  getFilterParamsNumber() {
    return {
      filterOptions: [
        "equals",
        "notEqual",
        "lessThan",
        "lessThanOrEqual",
        "greaterThan",
        "greaterThanOrEqual",
        "inRange",
        {
          displayKey: 'blanks',
          displayName: 'Is null',
          test: function (filterValue, cellValue) {
            return cellValue == null || cellValue == "";
          },
          hideFilterInput: true,
        },
        {
          displayKey: 'nonblanks',
          displayName: 'Is not null',
          test: function (filterValue, cellValue) {
            return cellValue != null && cellValue != "";
          },
          hideFilterInput: true,
        }
      ]
    };
  }
  // C153176-5583 Include Null & Not Null into filters from drop down in Grid
  getFilterParamsDate() {
    return {

      browserDatePicker: true,
      filterOptions: ['equals', 'lessThan', 'greaterThan', 'inRange'], // Common options
      defaultOption: 'equals', // Default filter option
      comparator: (filterLocalDateAtMidnight, cellValue) => {
        // This comparator helps compare the date values
        const cellDate = new Date(cellValue);
        if (cellDate < filterLocalDateAtMidnight) {
          return -1;
        }
        if (cellDate > filterLocalDateAtMidnight) {
          return 1;
        }
        return 0;
      },
      buttons: ["reset"]
    };
  }

  createKeyValueObj(value) {
    let updatedValue = value;
    if (updatedValue.includes('1 day')) {
      console.log(updatedValue);
    }
    // C170665-1515 Observation-- Not in Queue may be sorted as a value smaller than 0.
    if (updatedValue === 'NotInQ') {
      updatedValue = '-1 mins';
    }
    if (!updatedValue.includes('days')) {
      updatedValue = updatedValue.replace('day', 'days');
    }
    if (!updatedValue.includes('hours')) {
      updatedValue = updatedValue.replace('hour', 'hours');
    }
    if (!updatedValue.includes('mins')) {
      updatedValue = updatedValue.replace('min', 'mins');
    }
    let keyValue = {};
    const elemetsArray = updatedValue.split(' ');
    elemetsArray.forEach((element: any, index: any) => {
      if (isNaN(element)) {
        keyValue[element] = parseInt(elemetsArray[index - 1]);
      }
    });
    return keyValue;
  }

  private setColumnWidths(width) {

    const gridContainerWidth = localStorage.getItem('gridContainerWidth')?.toString() !== '0' && typeof(localStorage.getItem('gridContainerWidth')) === 'string' ? parseFloat(localStorage.getItem('gridContainerWidth')) : screen.width * 0.586 - 50//1074;
    let fromWidth = 165;
    let fromWidthMin = 155;
    let fromWidthMax = 400;
    let subjectWidth = gridContainerWidth * 0.205;
    let subjectWidthMin = gridContainerWidth * 0.1;
    let subjectWidthMax = 400;
    let assignedToWidth = gridContainerWidth * 0.15;
    let assignedToWidthMin = gridContainerWidth * 0.09;
    let assignedToWidthMax = 400
    let assignedGroupWidth = gridContainerWidth * 0.09;
    let assignedGroupWidthMin = gridContainerWidth * 0.07;
    let assignedGroupWidthMax = 400
    let receivedWidth = gridContainerWidth * 0.12;
    let receivedWidthMin = gridContainerWidth * 0.1;
    let receivedWidthMax = 400
    let ageWidth = 90;
    let ageWidthMin = 90;
    let ageWidthMax = 90;
    let annexWidth = gridContainerWidth * 0.15;
    let annexWidthMin = gridContainerWidth * 0.15;
    let annexWidthMax = screen.width;
    return {
      fromWidth,
      subjectWidth,
      assignedToWidth,
      assignedGroupWidth,
      receivedWidth,
      ageWidth,
      annexWidth,
      fromWidthMin,
      fromWidthMax,
      subjectWidthMin,
      subjectWidthMax,
      assignedToWidthMin,
      assignedToWidthMax,
      assignedGroupWidthMin,
      assignedGroupWidthMax,
      receivedWidthMin,
      receivedWidthMax,
      ageWidthMin,
      ageWidthMax,
      annexWidthMin,
      annexWidthMax
    };
  }

  formatDuration(ms: number) {
    if (!Number.isFinite(ms) || ms <= 0) return undefined;
    const totalSeconds = Math.floor(ms / 1000);
    const remainingMs = ms % 1000;
    const avgdays = Math.floor(totalSeconds / 86400);
    const avghours = Math.floor((totalSeconds % 86400) / 3600);
    const avgminutes = Math.floor((totalSeconds % 3600) / 60);
    const remainingSeconds = totalSeconds % 60;
    const parts: string[] = [];
    if (avgdays > 0) {
      parts.push(`${avgdays} ${avgdays === 1 ? 'day' : 'days'}`);
    }
    if (avghours > 0) {
      parts.push(`${avghours} ${avghours === 1 ? 'hour' : 'hours'}`);
    }
    if (avgminutes > 0) {
      parts.push(`${avgminutes} ${avgminutes === 1 ? 'min' : 'mins'}`);
    }
    if (avgdays === 0) {
      const secondsPart = this.formatSeconds(remainingSeconds, remainingMs, parts.length > 0);
      if (secondsPart) parts.push(secondsPart);
      
    } 
    return parts.length ? parts.join(' ') : undefined;
  }

  private formatSeconds(remainingSeconds: number, remainingMs: number, hasParts: boolean): string | undefined {
    const decimalSeconds = remainingSeconds + remainingMs / 1000;
    if (decimalSeconds <= 0) 
      return undefined;
    if (hasParts)              
      return `${remainingSeconds} ${remainingSeconds === 1 ? 'sec' : 'secs'}`;
    if (decimalSeconds >= 1)   
      return `${Math.floor(decimalSeconds)} ${Math.floor(decimalSeconds) === 1 ? 'sec' : 'secs'}`;
    return `${Number.parseFloat(decimalSeconds.toFixed(3))} secs`;
  }

  private parseDuration(str: string): number {
    if (!str) return 0;
    let dayrespTime = 0, dayrespHours = 0, mins = 0, secs= 0;
    const dayMatch = /\b(\d+)\s+days?\b/.exec(str);
    const hourMatch = /\b(\d+)\s+hours?\b/.exec(str);
    const minMatch = /\b(\d+)\s+mins?\b/.exec(str);
    const secMatch = /\b(\d+(?:\.\d+)?)\s+secs?\b/.exec(str);
    if (dayMatch) dayrespTime = Number.parseInt(dayMatch[1], 10);
    if (hourMatch) dayrespHours = Number.parseInt(hourMatch[1], 10);
    if (minMatch) mins = Number.parseInt(minMatch[1], 10);
    if (secMatch) secs = Number.parseFloat(secMatch[1]);
    return dayrespTime * 86400 + dayrespHours * 3600 + mins * 60 + secs;

  }

  durationComparator= (valueA: string, valueB: string): number =>{
    return this.parseDuration(valueA) - this.parseDuration(valueB);
  }

}

